import { ChangeDetectorRef, Component, Inject, Input, OnChanges, OnInit } from "@angular/core";
import { ANGULARJS_TRANSLATE, USER_PREFERENCES_SERVICE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";

/**
 * Componente com ícone para download de atualizações
 */
@Component({
    selector: "nms-download-update-icon",
    templateUrl: "./nms-download-update-icon.component.html",
    styleUrls: ["./nms-download-update-icon.component.scss"]
})
export class NmsDownloadUpdateIconComponent implements OnChanges, OnInit {

    @Input() url: string;
    @Input() origin: string;
    @Input() showTooltip: boolean;
    @Input() bottomPopover: string | boolean;

    private readonly DOWNLOAD_FIRMWARE_TOOLTIP_KEY: string = "DownloadFirmwareTooltip";

    tooltip = "";
    isSeen: boolean;

    constructor(@Inject(USER_PREFERENCES_SERVICE) private readonly userPreferenceService,
                private readonly cdr: ChangeDetectorRef,
                @Inject(ANGULARJS_TRANSLATE) private readonly translate) {
        this.tooltip =
            `<div class='tooltip-legend-wrapper'>
                <div class='legend-title'>
                    <h4>${this.translate.instant("nms-download-update-icon.tooltip.title")}</h4>
                </div>
                <p>${this.translate.instant("nms-download-update-icon.fw-update.tooltip")}</p>
            </div>`;
    }

    ngOnInit(): void {
        if (typeof this.bottomPopover === "string") {
            this.bottomPopover = this.bottomPopover === "true";
        }
    }

    ngOnChanges(): void {
        this.isSeen = this.verifyIfSeen(this.origin);
    }

    closeTooltip() {
        this.markAsSeen(this.origin);
    }

    download() {
        window.open(this.url, "_blank");
    }

    isTooltipVisible(): boolean {
        return !this.isSeen && this.showTooltip;
    }

    private markAsSeen(origin: string): void {
        this.isSeen = true;
        const seenFirmwareTooltips = this.userPreferenceService
            .loadPreferences({}, this.DOWNLOAD_FIRMWARE_TOOLTIP_KEY, ["items"]);

        if (seenFirmwareTooltips) {
            if (Array.isArray(seenFirmwareTooltips.items)) {
                seenFirmwareTooltips.items.push(origin);
            } else {
                seenFirmwareTooltips.items = [origin];
            }
        }

        this.userPreferenceService
            .savePreferences({ items: seenFirmwareTooltips.items }, this.DOWNLOAD_FIRMWARE_TOOLTIP_KEY, ["items"]);
        this.cdr.detectChanges();
    }

    private verifyIfSeen(origin: string): boolean {
        const seenFirmwareTooltips = this.userPreferenceService.loadPreferences(
            {},
            this.DOWNLOAD_FIRMWARE_TOOLTIP_KEY,
            ["items"]
        );

        if (seenFirmwareTooltips && Array.isArray(seenFirmwareTooltips.items)) {
            return seenFirmwareTooltips.items.some(item => item === origin);
        }

        return false;
    }

}
